import { render, staticRenderFns } from "./PurchaseGain.vue?vue&type=template&id=b14b6c4a&"
import script from "./PurchaseGain.vue?vue&type=script&lang=js&"
export * from "./PurchaseGain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports